<template>
	<section>
		<header-page
			name="resources"
			:title="$route.meta.title"
		/>
		<v-layout wrap pa-4 class="resource-editor-layout">
			<v-flex xs5 pr-3 class="resource-editor-panel resource-details-panel">
				<div class="resource-section-heading">
					<span class="resource-section-icon"><v-icon>description</v-icon></span>
					<div>
						<strong>Información del recurso</strong>
						<small>Datos de navegación y presentación</small>
					</div>
				</div>
				<v-layout wrap class="resource-fields-grid">
					<v-flex xs6 pr-2 pb-2>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Nombre"
							required
							v-model="$v.model.name.$model"
							:error="$v.model.name.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs6 pl-2 pb-2>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Título"
							required
							v-model="$v.model.title.$model"
							:error="$v.model.title.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs8 pr-2 pb-2>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="URL WEB"
							required
							v-model="$v.model.uri.$model"
							:error="$v.model.uri.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs4 pl-2 pb-2>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							type="Number"
							label="Fragmento móvil"
							required
							v-model="$v.model.numFragment.$model"
							:error="$v.model.numFragment.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs8 pr-2 pb-2>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Controlador"
							required
							v-model="$v.model.controller.$model"
							:error="$v.model.controller.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs4 pl-2 pb-2>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							type="number"
							min="1"
							label="Posición"
							v-model="model.position"
						/>
					</v-flex>
					<v-flex xs12 pb-2>
						<v-textarea
							background-color="white"
							box
							class="body-1"
							height="80"
							hide-details
							label="Descripción"
							no-resize
							required
							v-model="$v.model.description.$model"
							:error="$v.model.description.$error"
						>
						</v-textarea>
					</v-flex>
					<v-flex xs12 pb-2>						
						<v-layout wrap align-center>
							<v-text-field
								solo
								class="body-1 mx-2 mt-0"
								height="30px"
								hide-details
								readonly
								required
								label="Icono"
								v-model="$v.model.pathIcon.$model"
								:error="$v.model.pathIcon.$error"
							>
							</v-text-field>
							<upload-image 
								label-ref="up"
								label-for="image"
								input-id="image"
								@send-image="getImage"
							/>
						</v-layout>
					</v-flex>
					<v-flex xs12 pb-2>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Link de video"
							v-model="model.link"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 mb-3 class="resource-tag-section">
						<v-layout wrap row justify-space-between class="resource-tag-header">
							<v-flex class="resource-tag-title">
								<v-icon>local_offer</v-icon>
								<div>
									<label>Agregar etiqueta</label>
									<small>Se mostrará junto al nombre del recurso (Ej.: Nuevo, Beta, etc.)</small>
								</div>
							</v-flex>
							<v-flex class="resource-tag-switch">
								<v-switch
									class="mt-0"
									color="base"
									hide-details
									:label="flagNewName"
									v-model="model.flagNew"
								/>
							</v-flex>
						</v-layout>
						<v-layout v-if="model.flagNew" row wrap class="resource-language-grid">
							<v-flex
								xs12
								class="resource-language-field"
								v-for="(language, lanKey) in languagesByProject"
								:key="lanKey"
							>
								<v-text-field
									background-color="white"
									box
									class="body-1"
									hide-details
									:label="language.name"
									required
									v-model="model.newTitle[lanKey].title"
								></v-text-field>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs7 pl-3 class="resource-editor-panel resource-services-panel">
				<v-layout wrap>
					<v-flex xs12>
						<div class="resource-section-heading">
							<span class="resource-section-icon"><v-icon>cloud_queue</v-icon></span>
							<div>
								<strong>Web Services</strong>
								<small>Servicios relacionados con este recurso</small>
							</div>
						</div>
					</v-flex>
					<v-flex xs12 pb-2>
						<v-layout wrap class="service-search-bar">
							<v-flex xs5 pr-3>
								<v-select
									background-color="white"
									box
									class="body-1"
									hide-details
									label="Dominio"
									item-text="name"
									item-value="code"
									:items="domains"
									v-model="paramsService.domain"
								></v-select>
							</v-flex>
							<v-flex xs3 pr-3>
								<v-select
									background-color="white"
									box
									class="body-1"
									hide-details
									label="Método"
									item-text="name"
									item-value="code"
									:items="methods"
									v-model="paramsService.method"
								></v-select>
							</v-flex>
							<v-flex xs4>
								<v-layout>
									<v-flex xs9>
										<v-text-field
											background-color="white"
											box
											class="body-1"
											hide-details
											label="Nombre"
											v-model="paramsService.path"
										>
										</v-text-field>
									</v-flex>
									<v-flex xs3>
										<button
											type="button"
											class="btn-search"
											@click="openSearch">
											<v-icon color="primary">search</v-icon>
									</button>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs12>
						<resource-list
							:rows="rows"
							@edit-service="editService"
							@delete-service="openDialog"
						/>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				:is-loading="$v.$invalid || loading"
				:on-run-service="loading"
				@accept-button-clicked="createResource"
				@cancel-button-clicked="cancelCreateResource"
			/>
		</section>
		<action-sidebar
			:title="action.title"
			:value="action.value"
			:width="action.width"
			@close-modal="closeModal"
		>
			<resource-search 
				v-if="action.code === 'resource-search'"
				:code-project="codeProject"
				:params-service="paramsService"
				@add-service="addService"
				/>
			<service-edit 
				v-if="action.code === 'edit-service'"
				:domains="domains"
				:methods="methods"
				:service="dataEditService"
				@save-edit-service="saveEditService"
				@close="closeModal"
			/>	
		</action-sidebar>
		<v-dialog v-model="dialog" persistent max-width="500">
			<v-card>
				<v-card-title class="subheading">{{ dialogMessage }}</v-card-title>
				<v-card-actions class="justify-center">
					<v-btn
						class="btn-action"
						color="green"
						dark
						@click.native="deleteService"
					>
						SI
					</v-btn>
					<v-btn
						class="btn-action"
						color="error"
						dark
						@click.native="closeDialog"
					>
						NO
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</section>
</template>

<script>
import { required, requiredIf, numeric } from 'vuelidate/lib/validators';
import actionSidebar from '@/components/shared/action-sidebar';
import helper from '@/shared/helper';
import resourceList from '@/components/resource-service/resource-list';
import resourceSearch from '@/components/resource-service/resource-search';
import serviceEdit from '@/components/resource-service/service-edit';
import UploadImage from '@/components/shared/upload-image';

const { getLocalData } = helper;

function openSearch() {
	this.action.title = 'Web Service';
	this.action.code = 'resource-search';
	this.action.width = 700;
	this.action.value = true;
}

function closeModal() {
	this.action.title = '';
	this.action.code = null;
	this.action.value = false;
	this.paramsService = { ...this.paramsServiceDefault };
	this.dataEditService = {};
}

function editService(row) {
	this.dataEditService = { ...row };
	this.action.width = 500;
	this.action.title = 'Editar';
	this.action.code = 'edit-service';
	this.action.value = true;
}

async function loadData() {
	const requests = [
		this.$http.get(`projects/${this.codeProject}/domains`),
	];
	if (this.id) {
		requests.push(this.$http.get(`resource/${this.id}`));
	}
	try {
		const responses = await Promise.all(requests);
		const [domains] = responses;
		this.domains = domains.data || [];
		if (this.id) {
			this.loadServices();
			const resourceResponse = responses[1].data;
			const modelData = resourceResponse.data || resourceResponse;
			const resourceNewTitle = modelData.newTitle || { ...this.newTitle };
			if (modelData.flagNew && !modelData.newTitle) {
				const newTitleKeys = Object.keys(this.newTitle);
				newTitleKeys.forEach((k) => {
					const text = k === 'es' ? 'Nuevo' : 'New';
					this.$set(resourceNewTitle, k, { title: text });
				});
			}
			this.model = {
				...this.model,
				...modelData,
				action: Array.isArray(modelData.action) ? modelData.action : [modelData.action || 'GET'],
				newTitle: resourceNewTitle,
				numFragment: modelData.numFragment == null ? modelData.urlMovil || '' : modelData.numFragment,
				uri: modelData.uri || modelData.codeWeb || '',
			};
			this.model.moduleId = this.moduleId;
			this.model.services = this.model.services || [];
			this.rows = this.model.services || [];
			delete this.model.module;
		} else {
			this.model.newTitle = { ...this.newTitle };
		}
	} catch (error) {
		this.showError();
	}
}

function getImage({ urlImage }) {
	this.model.pathIcon = urlImage;
}

function flagNewName() {
	return this.model.flagNew ? 'Sí' : 'No';
}

function addService(row) {
	const index = this.rows.findIndex(r => r.id === row.id);
	if (index > -1) {
		this.showNotification('El servicio ya fue agregado a la lista', 'info');
	} else {
		this.rows.push(row);
		this.paramsService = { ...this.paramsServiceDefault };
		this.closeModal();
	}
}

function deleteService() {
	const index = this.rows.findIndex(r => r.id === this.dataEditService.id);
	if (index > -1) {
		this.rows.splice(index, 1);
		this.showNotification('El servicio ya fue eliminado a la lista', 'info');
		this.closeDialog();
	}
}

function cancelCreateResource() {
	this.goTo('page-resource');
}

async function createResource() {
	const services = this.rows.map((r) => {
		const newService = {};
		newService.id = r.id;
		newService.authorize = r.flagAuth;
		return newService;
	});
	const payload = {
		action: Array.isArray(this.model.action) ? this.model.action : [this.model.action || 'GET'],
		controller: this.model.controller,
		description: this.model.description,
		flagNew: this.model.flagNew,
		link: this.model.link || '',
		moduleId: this.moduleId,
		name: this.model.name,
		newTitle: this.model.flagNew ? this.model.newTitle : null,
		numFragment: Number(this.model.numFragment),
		pathIcon: this.model.pathIcon,
		position: Number(this.model.position || 1),
		services,
		title: this.model.title,
		uri: this.model.uri,
		urlMovil: Number(this.model.numFragment),
	};
	const method = this.id ? 'put' : 'post';
	const url = this.id ? `resource/${this.id}` : 'resource';
	const message = this.id ? 'editado' : 'creado';
	this.loading = true;
	try {
		await this.$http[method](url, payload);
		this.showNotification(`Recurso ${message} correctamente.`);
		this.goTo('page-resource');
	} catch (err) {
		this.showError();
	} finally {
		this.loading = false;
	}
}

function saveEditService(row) {
	const newRows = [...this.rows];
	const index = newRows.findIndex(r => r.id === row.id);
	if (index > -1) {
		newRows[index] = { ...row };
		this.rows = [...newRows];
		this.closeModal();
	}
}

async function loadServices() {
	try {
		const { data: response } = await this.$http.get(`resources/${this.id}/services`);
		this.rows = response.data.map((r) => {
			const newRow = { ...r };
			newRow.flagAuth = r.authorize;
			return newRow;
		});
	} catch (error) {
		this.showError();
	}
}

function openDialog(row) {
	this.dataEditService = { ...row };
	this.dialog = true;
	this.dialogMessage = `Desear eliminar ${row.name} de la lista de servicios del recurso`;
}

function closeDialog() {
	this.dataEditService = {};
	this.dialog = false;
	this.dialogMessage = '';
}

function validations() {
	const validation = {
		model: {
			controller: { required },
			description: { required },
			name: { required },
			newTitle: { required: requiredIf(() => !!this.model.flagNew) },
			numFragment: { required, numeric },
			pathIcon: { required },
			title: { required },
			uri: { required },
		},
	};
	return validation;
}

function created() {
	this.languagesByProject = getLocalData('project-languages');
	const languagesKeys = Object.keys(this.languagesByProject);
	this.newTitle = languagesKeys.reduce((a, k) => {
		const newA = { ...a };
		newA[k] = { title: '' };
		return newA;
	}, {});
	this.loadData();
}

function data() {
	return {
		action: {
			code: null,
			title: '',
			value: false,
			width: 524,
		},
		domains: [],
		loading: false,
		methods: [
			{ code: 'get', name: 'GET' },
			{ code: 'post', name: 'POST' },
			{ code: 'delete', name: 'DELETE' },
			{ code: 'patch', name: 'PATCH' },
		],
		languagesByProject: {},
		model: {
			action: ['GET'],
			controller: '',
			description: '',
			flagNew: false,
			link: '',
			moduleId: this.moduleId,
			name: '',
			newTitle: {},
			numFragment: '',
			pathIcon: '',
			position: 1,
			services: [],
			title: '',
			uri: '',
		},
		paramsService: {
			codeProject: this.codeProject,
			method: null,
			path: null,
			domain: null,
		},
		paramsServiceDefault: {
			codeProject: this.codeProject,
			method: null,
			path: null,
			domain: null,
		},
		rows: [],
		dataEditService: {},
		dialog: false,
		dialogMessage: '',
		newTitle: {},
	};
}

export default {
	name: 'page-resource-new-update',
	data,
	created,
	components: {
		actionSidebar,
		UploadImage,
		resourceList,
		resourceSearch,
		serviceEdit,
	},
	computed: {
		flagNewName,
	},
	methods: {
		closeModal,
		editService,
		openSearch,
		loadData,
		getImage,
		addService,
		deleteService,
		cancelCreateResource,
		createResource,
		saveEditService,
		loadServices,
		openDialog,
		closeDialog,
	},
	props: {
		moduleId: {
			type: [String, Number],
			required: true,
		},
		moduleName: {
			type: String,
			required: true,
		},
		id: {
			type: [Number, String],
		},
		codeApp: {
			type: [String, Number],
		},
		codeProject: {
			type: [String, Number],
		},
	},
	validations,
};
</script>
<style lang="scss">
.resource-editor-layout {
	align-items: flex-start;
	background: #f5f8fb;
	display: grid !important;
	grid-template-columns: minmax(420px, 5fr) minmax(0, 7fr);
	gap: 16px;
	padding-bottom: 78px !important;
}

.resource-editor-panel {
	background: #fff;
	border: 1px solid #dbe6ee;
	border-radius: 12px;
	box-shadow: 0 4px 14px rgba(31, 64, 91, 0.08);
	box-sizing: border-box;
	min-width: 0;
	padding: 14px !important;
}

.resource-editor-layout > .resource-editor-panel.flex {
	flex-basis: auto !important;
	max-width: none !important;
	width: auto !important;
}

.resource-details-panel {
	max-width: none;
}

.resource-services-panel {
	margin-left: 0;
	max-width: none;
}

.resource-section-heading {
	align-items: center;
	border-bottom: 1px solid #e4edf3;
	display: flex;
	gap: 10px;
	margin-bottom: 14px;
	padding: 0 2px 11px;
}

.resource-section-heading strong,
.resource-section-heading small {
	display: block;
}

.resource-section-heading strong {
	color: #29465e;
	font-size: 13px;
	letter-spacing: 0.35px;
	text-transform: uppercase;
}

.resource-section-heading small {
	color: #8195a6;
	font-size: 11px;
	margin-top: 2px;
}

.resource-section-icon {
	align-items: center;
	background: #e9f5fd;
	border-radius: 8px;
	display: inline-flex;
	height: 34px;
	justify-content: center;
	width: 34px;
}

.resource-section-icon .icon {
	color: #168be0 !important;
	font-size: 19px !important;
}

.resource-editor-layout .input-group--text-field,
.resource-editor-layout .input-group--select {
	margin-top: 0;
}

.resource-editor-layout .resource-fields-grid .input-group,
.resource-editor-layout .service-search-bar .input-group {
	background: #f8fafc !important;
	border: 1px solid #d4e1eb;
	border-radius: 8px;
	box-shadow: none;
	min-height: 50px;
	overflow: hidden;
}

.resource-editor-layout .resource-fields-grid > .flex > .v-input .v-input__slot,
.resource-editor-layout .service-search-bar .v-input .v-input__slot {
	background: #f8fafc !important;
	border: 1px solid #cfdce6 !important;
	border-radius: 8px !important;
	box-shadow: none !important;
	margin-bottom: 0 !important;
	min-height: 52px;
	padding: 0 12px !important;
}

.resource-editor-layout .resource-fields-grid > .flex > .v-input .v-input__slot::before,
.resource-editor-layout .resource-fields-grid > .flex > .v-input .v-input__slot::after,
.resource-editor-layout .service-search-bar .v-input .v-input__slot::before,
.resource-editor-layout .service-search-bar .v-input .v-input__slot::after {
	display: none !important;
}

.resource-editor-layout .resource-fields-grid > .flex > .v-input.v-input--is-focused .v-input__slot,
.resource-editor-layout .service-search-bar .v-input.v-input--is-focused .v-input__slot {
	background: #fff !important;
	border-color: #1A4338 !important;
	box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.12) !important;
}

.resource-editor-layout .resource-fields-grid > .flex > .v-input.error--text .v-input__slot {
	border-color: #ff6478 !important;
}

.resource-editor-layout .resource-fields-grid .v-label,
.resource-editor-layout .service-search-bar .v-label {
	color: #6f8291 !important;
	font-size: 13px;
}

.resource-editor-layout .resource-fields-grid input,
.resource-editor-layout .resource-fields-grid textarea {
	color: #29465e !important;
	font-size: 13px;
}

.resource-editor-layout .resource-fields-grid .v-textarea .v-input__slot {
	min-height: 88px;
	padding-bottom: 8px !important;
	padding-top: 8px !important;
}

.resource-editor-layout .resource-fields-grid .input-group::before,
.resource-editor-layout .resource-fields-grid .input-group::after,
.resource-editor-layout .service-search-bar .input-group::before,
.resource-editor-layout .service-search-bar .input-group::after {
	display: none !important;
}

.resource-editor-layout .resource-fields-grid .input-group__input,
.resource-editor-layout .service-search-bar .input-group__input {
	background: transparent !important;
	border: 0 !important;
	box-shadow: none !important;
}

.resource-editor-layout .input-group--focused {
	border-color: #1A4338;
	box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.1);
}

.resource-editor-layout .input-group--error {
	border-color: #ff6478;
}

.resource-fields-grid > .flex {
	box-sizing: border-box;
}

.resource-fields-grid .input-group--textarea {
	min-height: 82px !important;
}

.resource-fields-grid .layout.align-center {
	background: #f8fafc;
	border: 1px solid #d4e1eb;
	border-radius: 8px;
	flex-wrap: nowrap !important;
	padding: 6px;
}

.resource-fields-grid .layout.align-center .input-group {
	border: 0;
	min-width: 0;
}

.resource-fields-grid .layout.align-center .btn {
	flex: 0 0 auto;
	margin: 0 0 0 6px;
}

.resource-tag-section {
	background: #f8fafc;
	border: 1px solid #d9e5ed;
	border-radius: 10px;
	box-sizing: border-box;
	margin-top: 4px;
	padding: 12px;
}

.resource-tag-header {
	align-items: center;
	flex-wrap: nowrap !important;
}

.resource-tag-title {
	align-items: center;
	display: flex;
	min-width: 0;
}

.resource-tag-title > .icon {
	color: #2696df;
	font-size: 20px;
	margin-right: 9px;
}

.resource-tag-title label,
.resource-tag-title small {
	display: block;
}

.resource-tag-title label {
	color: #29465e;
	font-size: 13px;
	font-weight: 600;
}

.resource-tag-title small {
	color: #7f92a1;
	font-size: 10px;
	line-height: 1.35;
	margin-top: 2px;
}

.resource-tag-switch {
	flex: 0 0 auto !important;
	margin-left: 12px;
}

.resource-tag-switch .v-input,
.resource-tag-switch .input-group {
	margin: 0 !important;
	padding: 0 !important;
}

.resource-language-grid {
	display: grid !important;
	gap: 10px;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	margin-top: 12px;
}

.resource-language-field.flex {
	max-width: none !important;
	min-width: 0;
	width: auto !important;
}

.resource-tag-section .resource-language-field .v-input__slot {
	background: #fff !important;
	border: 1px solid #cfdce6 !important;
	border-radius: 8px !important;
	box-shadow: none !important;
	margin: 0 !important;
	min-height: 50px;
	padding: 0 12px !important;
}

.resource-tag-section .resource-language-field .v-input__slot::before,
.resource-tag-section .resource-language-field .v-input__slot::after {
	display: none !important;
}

.resource-tag-section .resource-language-field .v-input--is-focused .v-input__slot {
	border-color: #1A4338 !important;
	box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.12) !important;
}

.service-search-bar {
	align-items: stretch;
	background: #f7fafc;
	border: 1px solid #e1eaf1;
	border-radius: 10px;
	padding: 10px;
}

.resource-editor-layout .btn-search {
	background-color: map-get($colors, primary) !important;
	border-radius: 0 8px 8px 0;
	height: 100%;
	min-height: 50px;
	width: 100%;
}

.resource-editor-layout .btn-search .icon {
	color: #fff !important;
}

@media (max-width: 1050px) {
	.resource-editor-layout {
		grid-template-columns: 1fr;
	}

	.resource-details-panel,
	.resource-services-panel {
		margin-left: 0;
	}

	.resource-services-panel {
		margin-top: 16px;
	}
}

@media (max-width: 680px) {
	.resource-editor-layout {
		padding: 10px !important;
		padding-bottom: 78px !important;
	}

	.resource-fields-grid > .flex,
	.service-search-bar > .flex {
		flex-basis: 100%;
		max-width: 100%;
		padding-left: 0 !important;
		padding-right: 0 !important;
	}

	.service-search-bar > .flex + .flex {
		margin-top: 8px;
	}

	.resource-language-grid {
		grid-template-columns: 1fr;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/resources/page-resource-new-update.vue